import { date } from '@wordpress/date';
import { __ } from '@wordpress/i18n';
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import HTMLParser from 'react-html-parser';

// Helpers.
import { RESEARCH_ITEM } from '../../../config/prop-types';

// Styles.
import './style.scss';

// Images.
import IconCaret from '../../images/icon-caret.png';

const ResearchItem = ({
  activeSlug,
  item,
  setActiveSlug,
}) => {
  const [visible, setVisibility] = useState(false);

  /**
   * Set initial visibility for this item on load.
   */
  useEffect(() => {
    setVisibility(activeSlug.includes(item.slug));
  }, []);

  /**
   * Toggle item card visibility,
   */
  const toggleVisibility = () => {
    setVisibility(! visible);
    setActiveSlug(item.slug);
  };

  const {
    meta: {
      knight_foundation_krn_research_publish_date: metaDate,
      knight_foundation_krn_description: metaExcerpt,
      knight_foundation_krn_member: {
        name: memberName = '',
      } = {},
      knight_foundation_krn_external_link: link = '',
    },
    slug,
  } = item;
  const pubDate = metaDate || item.date;
  const publicationDate = date('M d, Y', pubDate);
  const postExcerpt = item.excerpt.rendered;
  const excerpt = metaExcerpt || HTMLParser(postExcerpt);

  return (
    <li
      aria-expanded={visible}
      className={
        classnames(
          'krn-research__item',
          'krn-research-item',
          slug === activeSlug && 'krn-research-item--type--priority',
          slug && `krn-research-item--slug--${slug}`,
        )
      }
      key={item.id}
    >
      <button
        className="krn-research-item__toggle"
        onClick={toggleVisibility}
      >
        <span className="krn-research-item__icon">
          <img src={IconCaret} alt="" />
        </span>
      </button>
      <button
        className="krn-research-item__name"
        onClick={toggleVisibility}
      >
        <div className="krn-research-item__name--title">
          {item.title.rendered}
        </div>
        {! visible ? (
          <div className="krn-research-item__name--detail">
            <span className="krn-research-item__network-member">
              {HTMLParser(memberName)}
            </span>
          </div>
        ) : null}
      </button>
      <div className="krn-research-item__wrapper">
        {excerpt && 0 < excerpt.length ? (
          <div className="excerpt krn-research-item__detail">
            <span className="krn-research-item__excerpt">
              {excerpt}
            </span>
          </div>
        ) : null}
        {memberName ? (
          <div className="excerpt krn-research-item__detail">
            <span className="krn-research-item__detail--label">
              {__('Network Member: ', 'knight-foundation-app')}
            </span>
            <span className="krn-research-item__network-member">
              {HTMLParser(memberName)}
            </span>
          </div>
        ) : null}
        {publicationDate ? (
          <div className="publication-date krn-research-item__detail">
            <span className="krn-research-item__detail--label">
              {__('Publication Date: ', 'knight-foundation-app')}
            </span>
            <span className="krn-research-item__date">
              {publicationDate}
            </span>
          </div>
        ) : null}
        {link ? (
          <a
            className="krn-research-item__publication"
            href={link}
          >
            View the Report
          </a>
        ) : null}
      </div>
    </li>
  );
};

ResearchItem.propTypes = {
  activeSlug: PropTypes.arrayOf(PropTypes.string).isRequired,
  item: PropTypes.shape(RESEARCH_ITEM).isRequired,
  setActiveSlug: PropTypes.func.isRequired,
};

export default ResearchItem;
